import React from "react";
import developerHeader from "../assets/developer.png";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div className=" h-screen w-screen overflow-hidden">
     
      <img
        alt="developer"
        src={developerHeader}
        className="w-[370px] h-[550px]md:h-40 min-[600px] absolute left-[50%] top-[20px] md:left-[5%] md:static"
      />

      <div className="absolute md:text-[40px] xl:left-[-20px] xl:text-[40px]  md:left-[0] md:w-screen p-6  md:static left-[20%] top-[40%] w-[619px] h-[250px] text-black text-[64px] font-normal">
        <p>   Hi! I'm Viviana and I'm a Junior Fullstack developer</p>
        <Link
          className="cursor-pointer text-[20px]  text-white bg-slate-500 mt-2 p-4"
          to="Projects"
          smooth="500"
        >
          Portfolio
        </Link>
      </div>
    </div>
  );
};

export default Home;
